var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("blExchangeAppointment.forespeakCnshk"),
                isShowFollow: false,
              },
              on: { opened: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  { ref: "form" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "vvLBlNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.voyageNoBlNo"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: true,
                                    type: "textarea",
                                    autosize: { minRows: 2, maxRows: 4 },
                                  },
                                  model: {
                                    value: _vm.vvLBlNo,
                                    callback: function ($$v) {
                                      _vm.vvLBlNo = $$v
                                    },
                                    expression: "vvLBlNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "paymentStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.paymentStatus"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: true,
                                      placeholder: _vm.$t(
                                        "blExchangeAppointment.select"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.paymentStatus,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "paymentStatus", $$v)
                                      },
                                      expression: "form.paymentStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.paymentStatusList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.codeValue,
                                        attrs: {
                                          value: Number(item.codeValue),
                                          label:
                                            _vm.language === "zh"
                                              ? item.displayValueCn
                                              : item.displayValue,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "forespeakStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.forespeakStatus"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: true,
                                      placeholder: _vm.$t(
                                        "blExchangeAppointment.select"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.forespeakStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "forespeakStatus",
                                          $$v
                                        )
                                      },
                                      expression: "form.forespeakStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.forespeakStatusList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.codeValue,
                                        attrs: {
                                          value: Number(item.codeValue),
                                          label:
                                            _vm.language === "zh"
                                              ? item.displayValueCn
                                              : item.displayValue,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "doType",
                                  label: _vm.$t("blExchangeAppointment.doType"),
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.form.doType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "doType", $$v)
                                      },
                                      expression: "form.doType",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { disabled: true, label: 0 } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.electronicBill"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-radio",
                                      { attrs: { disabled: true, label: 1 } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.paperBill"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticClass: "item-button" },
                      [
                        _vm.showCancel
                          ? _c(
                              "el-button",
                              {
                                staticClass: "btn-info-primary",
                                on: { click: _vm.handleCancel },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("btn.cancelAppointment")) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showSave
                          ? _c(
                              "el-button",
                              {
                                staticClass: "btn-primary",
                                on: { click: _vm.handleSave },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("btn.forespeakSave")) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("home.saveTip"),
                isShowFollow: false,
                visible: _vm.cancelForespeakBatchVisible,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.cancelForespeakBatchVisible = $event
                },
              },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticStyle: { margin: "20px 20px 0" } }, [
              _c(
                "div",
                {
                  staticClass: "table-container-new",
                  staticStyle: { "margin-top": "10px" },
                },
                [
                  _c("div", [
                    _c(
                      "h4",
                      {
                        staticStyle: {
                          "font-size": "17px",
                          color: "red",
                          "white-space": "pre-wrap",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t(this.cancelForespeakBatchMsg)))]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "right" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "text-align": "center",
                        margin: "20px 0",
                        width: "100px",
                      },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleCloseCnacelBatch },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("home.buttonClose")) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }